import React from "react";
import AutoComplete from "react-google-autocomplete";

export interface CoordAddress {
  lat: number;
  lng: number;
  address?: string;
  tmpCity?: string;
  tmpDistrict?: string;
  tmpWard?: string;
  tmpStreet?: string;
  placeId?: string;
  rate?: number;
  totalRate?: number;
  rateWant?: number;
  name?: string;
  mapUrl?: string;
  countReviews?: { count: number; star: number }[];
}

interface IGoogleMapAutoComplete {
  onPlaceSelected: (coordAddress: CoordAddress) => void;
  defaultBounds?: any;
}

export const GoogleMapAutoComplete = ({
  onPlaceSelected,
  defaultBounds,
}: IGoogleMapAutoComplete) => {
  return (
    <div>
      <AutoComplete
        options={{
          bounds: defaultBounds,
          types: ["establishment", "geocode"],
          componentRestrictions: { country: "vn" },
        }}
        style={{ width: "100%" }}
        language="vi"
        onPlaceSelected={(place) => {
          if (place.geometry) {
            onPlaceSelected({
              lat: place.geometry.location?.lat() || 0,
              lng: place.geometry.location?.lng() || 0,
              address: place.formatted_address || "",
              placeId: place.place_id,
            });
          }
        }}
      />
    </div>
  );
};
